<template>
  <section class="section cta" id="contact">
    <div class="wrap">
      <div class="sec-head reveal" v-reveal>
        <p class="sec-eyebrow">06 / CONTACT / 联系</p>
        <h2>加个微信, 先聊起来</h2>
        <p>说清你要解决什么问题。能做的, 给你方案; 做不到的, 直说。</p>
      </div>
      <div class="contact-card reveal" v-reveal>
        <div class="contact-info">
          <p class="contact-label">微信咨询 / WECHAT</p>
          <div class="wechat-row">
            <span class="wechat-id">{{ wechatId }}</span>
            <button class="copy-btn" type="button" @click="copyWechat">{{ copied ? '已复制' : '复制' }}</button>
          </div>
          <p class="contact-note">添加企业微信, 直接沟通。添加时请简要说明来意。</p>
          <div class="contact-meta">
            <div><span class="meta-label">工作时间</span>周一至周五 9:00 - 18:00</div>
            <div><span class="meta-label">所在地</span>贵州贵阳, 服务全国</div>
          </div>
        </div>
        <div class="qr-box">
          <div class="qr-frame">
            <img src="@/assets/qr-code.png" alt="企业微信二维码">
          </div>
          <p>扫码添加企业微信</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  data() {
    return {
      wechatId: 'xxjun9527',
      copied: false
    }
  },
  methods: {
    copyWechat() {
      const done = () => {
        this.copied = true
        setTimeout(() => {
          this.copied = false
        }, 2000)
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.wechatId).then(done, () => this.fallbackCopy(done))
      } else {
        this.fallbackCopy(done)
      }
    },
    fallbackCopy(done) {
      const ta = document.createElement('textarea')
      ta.value = this.wechatId
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
      } catch (e) {
        // 忽略, 复制失败时用户可手动选择
      }
      document.body.removeChild(ta)
      done()
    }
  }
}
</script>

<style scoped>
.cta {
  text-align: center;
}

.cta .sec-head {
  margin-bottom: 40px;
}

.cta .sec-head p {
  margin-left: auto;
  margin-right: auto;
}

.cta h2 {
  font-size: 38px;
  font-weight: 600;
  letter-spacing: -0.3px;
  margin-bottom: 16px;
}

.contact-card {
  max-width: 720px;
  margin: 0 auto;
  text-align: left;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 36px;
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 36px;
  align-items: center;
}

.contact-label {
  font-family: var(--mono);
  font-size: 12px;
  color: var(--ink-3);
  margin-bottom: 10px;
}

.wechat-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.wechat-id {
  font-family: var(--mono);
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.copy-btn {
  font-family: var(--mono);
  font-size: 12px;
  color: var(--ink-2);
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 5px 12px;
  cursor: pointer;
  transition: all 0.15s;
}

.copy-btn:hover {
  color: var(--accent);
  border-color: var(--accent);
}

.contact-note {
  font-size: 14px;
  color: var(--ink-2);
  margin-bottom: 20px;
}

.contact-meta {
  display: grid;
  gap: 8px;
  font-size: 13.5px;
  color: var(--ink-2);
}

.contact-meta .meta-label {
  font-family: var(--mono);
  font-size: 11.5px;
  color: var(--ink-3);
  display: inline-block;
  min-width: 64px;
  margin-right: 10px;
}

.qr-box {
  text-align: center;
}

.qr-frame {
  width: 180px;
  height: 180px;
  margin: 0 auto 12px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.qr-box img {
  width: 156px;
  height: 156px;
  object-fit: contain;
}

.qr-box p {
  font-family: var(--mono);
  font-size: 12px;
  color: var(--ink-3);
}

@media (max-width: 860px) {
  .cta h2 {
    font-size: 30px;
  }

  .contact-card {
    grid-template-columns: 1fr;
    gap: 24px;
    padding: 28px;
  }

  .wechat-id {
    font-size: 20px;
  }
}
</style>
